import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useUISettings } from '../context/UISettingsContext';
import {
  LEGAL_EFFECTIVE_DATE,
  LEGAL_VERSION,
  privacyPolicyPL,
  privacyPolicyEN,
  termsPL,
  termsEN,
} from '../content/legalContent';

export default function LegalDocument() {
  const location = useLocation();
  const { language, t } = useUISettings();
  const isPrivacy = location.pathname.startsWith('/privacy');

  const doc = isPrivacy
    ? language === 'pl' ? privacyPolicyPL : privacyPolicyEN
    : language === 'pl' ? termsPL : termsEN;

  const title = isPrivacy ? t('legal.privacyTitle') : t('legal.termsTitle');

  return (
    <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-3xl flex-col px-5 py-24">
      <Link
        to="/"
        className="mb-8 inline-flex w-fit items-center gap-2 rounded-full border border-[var(--app-border)] bg-[var(--app-surface)] px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.14em] text-[var(--app-text-muted)] transition-colors hover:text-[var(--app-text)]"
      >
        <ArrowLeft size={13} />
        Data Maturity & AI Readiness
      </Link>

      <article className="rounded-md border border-[var(--app-border)] bg-[var(--app-surface-strong)] px-6 py-7 shadow-[0_24px_70px_-42px_rgba(15,23,42,0.45)] md:px-8 md:py-9">
        <p className="mb-3 text-[10px] font-black uppercase tracking-[0.22em] text-[var(--app-accent)]">
          {language === 'pl'
            ? `Wersja ${LEGAL_VERSION} — obowiązuje od ${LEGAL_EFFECTIVE_DATE}`
            : `Version ${LEGAL_VERSION} — effective ${LEGAL_EFFECTIVE_DATE}`}
        </p>
        <h1 className="mb-3 text-3xl font-black leading-tight text-[var(--app-text)] md:text-4xl">
          {title}
        </h1>
        <p className="mb-8 text-sm font-semibold text-[var(--app-text-muted)]">
          {language === 'pl'
            ? 'Seargin sp. z o.o., ul. Chrzanowskiego 11, 80-278 Gdańsk, Polska — KRS: 499229, NIP-UE: PL5833165868 — info@seargin.com'
            : 'Seargin sp. z o.o., ul. Chrzanowskiego 11, 80-278 Gdańsk, Poland — KRS: 499229, VAT-EU: PL5833165868 — info@seargin.com'}
        </p>

        <div className="space-y-4 text-sm leading-7 text-[var(--app-text-muted)]">
          {doc.intro.map((p, idx) => (
            <p key={`intro-${idx}`}>{p}</p>
          ))}

          {doc.sections.map((section, sIdx) => (
            <section key={`s-${sIdx}`} className="pt-4">
              {section.heading && (
                <h2 className="mb-2 text-base font-bold text-[var(--app-text)]">
                  {section.heading}
                </h2>
              )}
              <div className="space-y-3">
                {section.paragraphs.map((p, pIdx) => (
                  <p key={`s-${sIdx}-p-${pIdx}`} className="whitespace-pre-line">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </article>
    </div>
  );
}
